/* tslint:disable */
/* eslint-disable */
export enum IdentificationTypeEnum {
  NzDriverLicense = 'NzDriverLicense',
  NzPassport = 'NzPassport',
  OverseasPassport = 'OverseasPassport',
  Other = 'Other'
}
